import type { PerformanceEventName, PerformanceMeasure } from '@ms/yammer-telemetry';
import { endAndReportPerformanceMeasure, startPerformanceMeasure } from '@ms/yammer-telemetry';
import type { PerformanceEventProperties } from '@ms/yammer-telemetry-support';

import type { GraphqlOperation, ManagedApiRequest } from './types';

const startApiMeasurement = (
  eventName: Extract<PerformanceEventName, 'managed_api_action' | 'api_fetch'>,
  apiMeasureName: string
) => startPerformanceMeasure(eventName, apiMeasureName);

type EndMeasurementProperties = PerformanceMeasure & {
  readonly eventProperties: PerformanceEventProperties;
};

const endApiPerformanceMeasure = (properties: EndMeasurementProperties) => {
  endAndReportPerformanceMeasure(properties);
};

type GetApiMeasureName = (request: ManagedApiRequest) => string;
export const getApiMeasureName: GetApiMeasureName = ({ apiName, body, requestType }) =>
  requestType === 'Graphql' ? (body as GraphqlOperation).operationName : apiName || 'unknown_api';

export type StartMeasurement = (apiMeasureName: string) => PerformanceMeasure;

export const startManagedApiMeasurement: StartMeasurement = (apiMeasureName) =>
  startApiMeasurement('managed_api_action', apiMeasureName);

export const startFetchMeasurement: StartMeasurement = (apiMeasureName) =>
  startApiMeasurement('api_fetch', apiMeasureName);

export type EndMeasurement = (properties: EndMeasurementProperties) => void;

export const endFetchMeasurement: EndMeasurement = (properties) => {
  endApiPerformanceMeasure(properties);
};

export const endManagedApiMeasurement: EndMeasurement = (properties) => {
  endApiPerformanceMeasure(properties);
};
